import { UploadFile } from "@mui/icons-material";
import SaveIcon from "@mui/icons-material/Save";
import { LoadingButton } from "@mui/lab";
import { Grid, MenuItem, Stack } from "@mui/material";
import { FileSection, FormDatePicker, FormTextField } from "components/atoms";
import { DetailTableTabs, ReportHeader } from "components/molecules";
import { ECommonDialogType } from "components/molecules/CommonDialog";
import { FormikHelpers, useFormik } from "formik";
import { DialogHelper, StatusHelper } from "helpers";
import { usePaginationRequest } from "hooks";
import { isUndefined } from "lodash";
import {
  EReceiveStatus,
  IDownloadLocationListConfirmPeriodicCycleCountRequest,
  IGetPeriodCycleCountRequest,
  IPeriodCycleCount,
  IPeriodicCycleCountConfirmLocationRequest,
} from "model";
import { ECountType } from "model/Type/ECountType";
import React, { useState } from "react";
import { useHistory, useLocation, useParams } from "react-router-dom";
import {
  CycleCountActions,
  DownloadActions,
  LoadingOrderActions,
} from "redux/actions";
import {
  useAppDispatch,
  useAppSelector,
} from "redux/configurations/reduxHooks";
import { CycleCountApiService } from "services";
import { CURRENT_PAGE_SIZE, EXPORT_FILE_NAME, FIRST_PAGE } from "utils/Const";

import { I18nTranslator, translations } from "utils/i18n";
import {
  CheckedLocationList,
  ConfirmLocationList,
  LocationList,
} from "./components";
const _fileId = "import-receive-document";

const PeriodicCycleCountDetail = () => {
  const location = useLocation();
  const history = useHistory();

  const isAdd = location.pathname.includes("new");
  const params = useParams<{
    id: string;
    doImportCode: string;
    description: string;
  }>();

  const fileRef = React.useRef<any>();

  const action = useAppSelector((state) => state.ReceiveReducer.action);
  const downloading = useAppSelector(
    (state) => state.AppConfigReducer.downloading
  );

  const dispatch = useAppDispatch();
  const [request] = useState({ id: params.id });
  const { loading, result } = usePaginationRequest<
    IGetPeriodCycleCountRequest,
    IPeriodCycleCount[]
  >(request, CycleCountApiService.getPeriodicCycleCount, []);

  const handleFileSelected = (files: FileList) => {
    if (files) {
      const file = files.item(0);
      DialogHelper.open({
        title: I18nTranslator(translations.periodicCycleCount.warning),
        message: I18nTranslator(translations.periodicCycleCount.confirmImport1),
        type: ECommonDialogType.WARNING,
        onConfirm: () => {
          DialogHelper.open({
            title: I18nTranslator(translations.periodicCycleCount.warning),
            message: I18nTranslator(
              translations.periodicCycleCount.confirmImport2
            ),
            type: ECommonDialogType.WARNING,
            onConfirm: () => {
              DialogHelper.openConfirmImportDialog({
                title: I18nTranslator(
                  translations.periodicCycleCount.confirmImport3
                ),
                fileName: file?.name!,
                onConfirm: () => {
                  const request: IPeriodicCycleCountConfirmLocationRequest = {
                    cycleCountPeriodID: params?.id,
                    description: "",
                    file: file,
                  };
                  dispatch(
                    CycleCountActions.importPeriodicCycleCountConfirmLocation.request(
                      request
                    )
                  );
                },
              });
            },
          });
        },
      });
    }
  };

  const tabsName = [
    I18nTranslator(translations.periodicCycleCount.locationList),
    I18nTranslator(translations.periodicCycleCount.checkedLocationList),
    I18nTranslator(translations.periodicCycleCount.updatedLocationlist),
  ];

  const onDownloadLocationListConfirmPeriodicCycleCount = async () => {
    const request: IDownloadLocationListConfirmPeriodicCycleCountRequest = {
      fileName: EXPORT_FILE_NAME.listConfirmCycleCountLocation,
      cycleCountPeriodID: params?.id || "",
    };
    dispatch(
      DownloadActions.downloadLocationListConfirmPeriodicCycleCount.request(
        request
      )
    );
  };

  const tabsPanel = [
    <LocationList id={params.id} />,
    <CheckedLocationList id={params.id} />,
    <ConfirmLocationList id={params.id} />,
  ];

  return (
    <>
      <FileSection
        ref={fileRef}
        id={_fileId}
        onFileSelected={handleFileSelected}
      />
      <div
        style={{
          display: "flex",
          flex: 1,
          flexDirection: "column",
          height: "100%",
        }}
      >
        <DetailHeader
          loading={loading}
          data={
            isUndefined(result.data)
              ? ({} as IPeriodCycleCount)
              : result.data[0]
          }
        />
        <DetailTableTabs
          tabsName={tabsName}
          tabsPanel={tabsPanel}
          headerButtons={
            <Stack direction={"row"} spacing={2}>
              <LoadingButton
                loading={downloading}
                component={"span"}
                startIcon={<UploadFile />}
                variant="contained"
                onClick={onDownloadLocationListConfirmPeriodicCycleCount}
              >
                {I18nTranslator(translations.button.exportCheckedLocationList)}
              </LoadingButton>
            </Stack>
          }
        />
      </div>
    </>
  );
};

const DetailHeader = (props: {
  loading: boolean;
  data?: IPeriodCycleCount;
}) => {
  const location = useLocation();
  const isAdd = location.pathname.includes("new");
  const params = useParams<{
    id: string;
    code: string;
  }>();
  const dispatch = useAppDispatch();
  const action = useAppSelector((state) => state.ReceiveReducer.action);
  const [request, setRequest] = useState<IGetPeriodCycleCountRequest>({
    id: params.id,
    pageNumber: FIRST_PAGE,
    pageSize: CURRENT_PAGE_SIZE,
  });

  const formik = useFormik<any>({
    initialValues: props.data || {},
    enableReinitialize: true,
    onSubmit: (values: any, { validateForm }: FormikHelpers<any>) => {
      validateForm().then(() => {});
    },
  });

  const onDownloadLocationListPeriodicCycleCount = async () => {
    const request: IDownloadLocationListConfirmPeriodicCycleCountRequest = {
      fileName: EXPORT_FILE_NAME.listCycleCountLocation,
      cycleCountPeriodID: params?.id || "",
    };
    dispatch(
      DownloadActions.downloadLocationListPeriodicCycleCount.request(
        request
      )
    );
  };


  return (
    <ReportHeader
      title={I18nTranslator(
        translations.periodicCycleCount.cycleCountDetailDocs
      )}
      description={params.code}
      formik={formik}
      loading={
        props.loading ||
        action.includes(LoadingOrderActions.updateLODocument.requestName)
      }
      // confirmButtonText={I18nTranslator(translations.button.save)}
      // confirmButtonIcon={<SaveIcon />}
      hideSearch
      renderButtons={
        <Stack direction={"row"} spacing={2}>
          <label htmlFor={_fileId}>
            <LoadingButton
              component={"span"}
              startIcon={<UploadFile />}
              variant="contained"
            >
              {I18nTranslator(translations.button.importCycleCountDocument)}
            </LoadingButton>
          </label>
          <LoadingButton
            component={"span"}
            startIcon={<UploadFile />}
            variant="contained"
            onClick={onDownloadLocationListPeriodicCycleCount}
          >
            {I18nTranslator(translations.button.exportDocs)}
          </LoadingButton>
        </Stack>
      }
    >
      <Grid container xs={12} item columnSpacing={2}>
        <Grid xs={3} item>
          <FormDatePicker
            id="fromDate"
            label={I18nTranslator(translations.fromDate)}
          />
        </Grid>
        <Grid xs={3} item>
          <FormDatePicker
            id="toDate"
            label={I18nTranslator(translations.toDate)}
          />
        </Grid>
        <Grid xs={3} item>
          <FormTextField
            disabled
            label={I18nTranslator(translations.periodicCycleCount.countType)}
            select
            id="countType"
          >
            <MenuItem value={ECountType.LOCATION}>
              {I18nTranslator(translations.type.location)}
            </MenuItem>
            <MenuItem value={ECountType.PRODUCT}>
              {I18nTranslator(translations.type.product)}
            </MenuItem>
          </FormTextField>
        </Grid>
        <Grid xs={3} item>
          <FormTextField
            label={I18nTranslator(translations.status)}
            id="status"
            renderValue={() =>
              StatusHelper.getReceiveStatusString(
                formik.values.status as EReceiveStatus
              )
            }
            disabled
          />
        </Grid>
      </Grid>
      <Grid container xs={12} item columnSpacing={2}>
        <Grid xs={12} item>
          <FormTextField
            label={I18nTranslator(translations.description)}
            id="description"
          />
        </Grid>
      </Grid>
    </ReportHeader>
  );
};

export default PeriodicCycleCountDetail;
